"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
exports.colors = {
  WomOriginal: '#491966',
  WomCorp: '#4D008C',
  WomCorp20: '#DBCCE8',
  WomCorp40: '#A67FC5',
  WomCorp80: '#270046',
  WomCTA: '#E92070',
  WomCTA20: '#FBD2E2',
  WomCTA40: '#F48FB7',
  WomCTA80: '#751038',
  NotificacionesRojo: '#FD3A4A',
  NotificacionesVerde: '#33CC9E',
  NotificacionesAmarillo: '#FFC71E',
  Neutros0: '#FFFFFF',
  Neutros5: '#EFF1F3',
  Neutros5_60: 'rgba(239, 241, 243, 0.6)',
  NeutrosDeshabilitado: '#E2E6EA',
  Neutros20: '#C9CFD7',
  Neutros40: '#8D94A5',
  Neutros60: '#494C66',
  Neutros90: '#0E141D',
  GradientesAlphaH: 'linear-gradient(270deg, #ED1E79 0%, #451287 100%)'
};